import React from "react";
import styles from "./index.module.css";

interface YouTubeEmbedProps {
  videoId: string; // The YouTube video ID
}

const Video: React.FC<YouTubeEmbedProps> = ({ videoId }) => {
  return (
    <div className={styles.outer}>
      <iframe
        className={styles.inner}
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default Video;
